import { Swiper } from 'swiper';
import { Fancybox } from '@fancyapps/ui';
import '@fancyapps/ui/dist/fancybox/fancybox.css';
import 'swiper/css'; // Import Swiper CSS

document.addEventListener('DOMContentLoaded', () => {
	const galleryBlocks = document.querySelectorAll('.gallery-block');

	if (galleryBlocks.length > 0) {
		window.addEventListener('load', handleGallerySwiper);
		window.addEventListener('resize', handleGallerySwiper);

		let gallerySwiper = {};

		function handleGallerySwiper() {
			galleryBlocks.forEach((galleryBlock) => {
				const galleryId = galleryBlock.getAttribute('id');
				const swiperContainer = galleryBlock.querySelector('.swiper');
				const galleryWrapper = galleryBlock.querySelector('.gallery-wrapper');
				const galleryImages = galleryBlock.querySelectorAll('.gallery-image');

				Fancybox.bind('[data-fancybox]');

				if (window.innerWidth >= 40 * 16) {
					// Destroy Swiper if it exists
					if (gallerySwiper[galleryId]) {
						gallerySwiper[galleryId].destroy(true, true);
						gallerySwiper[galleryId] = null;

						// Reset styles
						if (galleryWrapper) galleryWrapper.removeAttribute('style');
						galleryImages.forEach((image) => {
							image.removeAttribute('style');
						});
					}
				} else {
					// Initialize Swiper if not already initialized
					if (!gallerySwiper[galleryId]) {
						gallerySwiper[galleryId] = new Swiper(swiperContainer, {
							slidesPerView: 1,
							spaceBetween: 16,
							loop: false,
						});
					}
				}
			});
		}
	}
});
